export default class Fare {
    bus_type?:string;
    min_price?:number;
    per_km?:number;
}
